import { Apollo } from 'src/gql/generated';

export function questionTypeToReportColumnDataType(
  questionType: Apollo.ExtractionQuestionType
): Apollo.ReportColumnDataType {
  switch (questionType) {
    case Apollo.ExtractionQuestionType.Date:
      return Apollo.ReportColumnDataType.Date;
    case Apollo.ExtractionQuestionType.Number:
      return Apollo.ReportColumnDataType.Number;
    case Apollo.ExtractionQuestionType.Boolean:
      return Apollo.ReportColumnDataType.Boolean;
    case Apollo.ExtractionQuestionType.Text:
      return Apollo.ReportColumnDataType.String;
    // MUI doesn't have a multiSelect type, so we use singleSelect.
    case Apollo.ExtractionQuestionType.SingleSelect:
    case Apollo.ExtractionQuestionType.MultiSelect:
      return Apollo.ReportColumnDataType.SingleSelect;
  }
}
